﻿import * as React from 'react';
import { Table } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import IImageEditor from './IImageEditor';
import ImageEditorsListRow from './ImageEditorsListRow';

interface IImageEditorsListProps {
    imageEditors: any;
    deleteUser: (id: number) => void;
    editUser: (id: number) => void;
}

const ImageEditorsList = (props: IImageEditorsListProps) => {
    const imageEditors = [...props.imageEditors];
    return (
        <Table responsive hover>
            <thead>
                <tr>
                    <th>{Translate('image-editor/list/header/name')}</th>
                    <th>{Translate('image-editor/list/header/role')}</th>
                    <th>{Translate('image-editor/list/header/email-address')}</th>
                    <th>{Translate('image-editor/list/header/phone-number')}</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {imageEditors
                    .sort((a: IImageEditor, b: IImageEditor) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }

                        return 0;
                    })
                    .map((u: IImageEditor) => {
                        return (
                            <ImageEditorsListRow
                                imageEditor={u}
                                key={u.id}
                                onDelete={props.deleteUser}
                                onEdit={props.editUser}
                            />
                        );
                    })}
            </tbody>
        </Table>
    );
};

export default ImageEditorsList;
